import {
  FETCH_STATE_SUCCESS_ACTION,
  FETCH_DISTRICT_SUCCESS_ACTION,
  FETCH_DISTRICT_SEARCH_SUCCESS_ACTION,
  FILTER_BY_STATE_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_STATE_SUCCESS_ACTION:
     
      return {
        ...state,
        stateList: action.payload.rows,
       
      };

    case FETCH_DISTRICT_SUCCESS_ACTION:
      return {
        ...state,
        DistrictList: action.payload.rows,
        districtDtlsCount: action.payload.count,
      };
    

    case FETCH_DISTRICT_SEARCH_SUCCESS_ACTION:
     
      return {
        ...state,
        DistrictListSearch: action.payload.rows,
        DistrictSearchCount: action.payload.count
      };

      case FILTER_BY_STATE_SUCCESS_ACTION:
     
        return {
          ...state,
          FilterDistrictList: action.payload.rows,
          FilterDistrictCount: action.payload.count,
          
        };

    default:
      return {
        ...state,
      };
  }
}
